import { render, staticRenderFns } from "./ColorPointsHeader.vue?vue&type=template&id=33d07a6f&"
import script from "./ColorPointsHeader.vue?vue&type=script&lang=js&"
export * from "./ColorPointsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ColorPointsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports